import { option } from 'fp-ts';


// eslint-disable-next-line
const __SERVER__ = typeof global.__SERVER__ !== 'undefined' ? global.__SERVER__ : null;

export const maybeServer = option.fromNullable(__SERVER__);



// WEBPACK FOOTER //
// ./src/helpers/server.js